<template>
  <div class="faq-page">
    <div class="admin-nav">
      <ul class="nav">
        <li><a href="#">Home</a></li>
        <li><a href="#">Help & Support</a></li>
        <li><a href="#" aria-current="page">FAQs</a></li>
      </ul>
    </div>

    <section class="faq-hero">
      <div class="hero-copy">
        <p class="hero-eyebrow">Knowledge Base</p>
        <h1>Manage support guidance.</h1>
        <p class="hero-description">
          Keep common questions clear, current, and easy to maintain so teams and partners can
          self-serve with confidence.
        </p>

        <div class="hero-actions">
          <router-link to="/admin/add-faq" class="hero-action hero-action--primary">
            <i class="fas fa-plus"></i>
            Add New FAQ
          </router-link>
          <span class="hero-action hero-action--ghost">Support content administration</span>
        </div>
      </div>

      <div class="hero-metrics">
        <div class="metric-card">
          <span class="metric-label">Published entries</span>
          <strong class="metric-value">{{ faqItems.length }}</strong>
        </div>
        <div class="metric-card">
          <span class="metric-label">Category</span>
          <strong class="metric-value">Project Inventory</strong>
        </div>
      </div>
    </section>

    <section class="faq-shell">
      <div class="shell-header">
        <div>
          <p class="shell-kicker">Created FAQs</p>
          <h2>Questions currently available to users</h2>
        </div>
      </div>

      <div class="faq-list">
        <article v-for="item in faqItems" :key="item.id" class="faq-card">
          <b-button
            :id="`faq-toggle-${item.id}`"
            v-b-toggle="`faq-collapse-${item.id}`"
            class="faq-card__trigger"
            variant="link"
          >
            <span class="faq-card__content">
              <span class="faq-card__icon">
                <span class="when-closed"><i class="fa fa-caret-down" aria-hidden="true"></i></span>
                <span class="when-opened"><i class="fa fa-caret-up" aria-hidden="true"></i></span>
              </span>
              <span class="faq-card__text">
                <span class="faq-card__title">{{ item.question }}</span>
                <span class="faq-card__meta">Project Inventory FAQ</span>
              </span>
            </span>

            <span class="faq-card__actions" @click.stop>
              <router-link to="/admin/edit-faq" class="faq-action" title="Edit FAQ">
                <i class="fa fa-edit" aria-hidden="true"></i>
              </router-link>
              <button type="button" class="faq-action faq-action--danger" title="Delete FAQ">
                <i class="fa fa-trash" aria-hidden="true"></i>
              </button>
            </span>
          </b-button>

          <b-collapse :id="`faq-collapse-${item.id}`" class="faq-card__collapse">
            <div class="faq-card__answer">
              {{ item.answer || 'Answer content will be added here.' }}
            </div>
          </b-collapse>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AdminFaqPage',
  data() {
    return {
      faqItems: [
        {
          id: 1,
          question: 'How do I upload projects?',
          answer:
            'To upload projects, click the health projects tab on the menu bar, click add project, and fill the form provided.',
        },
        {
          id: 2,
          question: 'How many submissions am I allowed to make?',
          answer: '',
        },
        {
          id: 3,
          question: 'Who can I contact if I need help?',
          answer: '',
        },
        {
          id: 4,
          question: 'I can’t find the health project I’m looking for. What do I do?',
          answer: '',
        },
        {
          id: 5,
          question: 'How do I know if my submission has been accepted?',
          answer: '',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.faq-page {
  padding: 1.75rem 1rem 2.5rem;
  background: radial-gradient(circle at top left, rgba(48, 171, 76, 0.12), transparent 24%),
    linear-gradient(180deg, #f5faf6 0%, #eff5f0 100%);
  min-width: 0;
  overflow-x: hidden;
}

.admin-nav {
  margin-bottom: 1rem;
}

.admin-nav .nav {
  gap: 0.6rem;
  padding: 0;
}

.admin-nav ul li {
  list-style: none;
}

.admin-nav ul li a {
  display: inline-flex;
  align-items: center;
  padding: 0.45rem 0.9rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.8);
  color: #40604a;
  font-size: 0.82rem;
  text-decoration: none;
}

.faq-hero {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1.5rem;
  padding: 2rem;
  margin-bottom: 1.5rem;
  border: 1px solid rgba(28, 68, 38, 0.08);
  border-radius: 28px;
  background: linear-gradient(135deg, rgba(10, 33, 17, 0.96), rgba(23, 72, 36, 0.88)),
    linear-gradient(140deg, #16391f 0%, #30ab4c 100%);
  box-shadow: 0 24px 80px rgba(17, 41, 24, 0.16);
  color: #f7fff7;
}

.hero-copy {
  max-width: 48rem;
}

.hero-eyebrow,
.shell-kicker {
  margin-bottom: 0.45rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.hero-eyebrow {
  color: rgba(247, 255, 247, 0.72);
}

.faq-hero h1 {
  margin-bottom: 0.75rem;
  font-size: clamp(2rem, 3vw, 3rem);
  line-height: 1.1;
  color: #ffffff;
}

.hero-description {
  margin: 0;
  max-width: 40rem;
  color: rgba(247, 255, 247, 0.8);
  line-height: 1.75;
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 1.4rem;
}

.hero-action {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.9rem 1.15rem;
  border-radius: 16px;
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 700;
}

.hero-action--primary {
  background: linear-gradient(135deg, #ffffff, #eff7f0);
  color: #1e6b31;
  box-shadow: 0 16px 30px rgba(9, 24, 13, 0.16);
}

.hero-action--ghost {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: rgba(247, 255, 247, 0.82);
}

.hero-metrics {
  display: grid;
  grid-template-columns: repeat(2, minmax(140px, 1fr));
  gap: 1rem;
  min-width: 18rem;
}

.metric-card {
  padding: 1rem 1.1rem;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.08);
}

.metric-label {
  display: block;
  margin-bottom: 0.35rem;
  font-size: 0.8rem;
  color: rgba(247, 255, 247, 0.72);
}

.metric-value {
  font-size: 1.2rem;
  color: #ffffff;
}

.faq-shell {
  padding: 1.6rem;
  border: 1px solid rgba(24, 57, 31, 0.08);
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.72);
  box-shadow: 0 18px 60px rgba(22, 50, 28, 0.08);
  backdrop-filter: blur(10px);
}

.shell-header {
  margin-bottom: 1.3rem;
}

.shell-kicker {
  color: #2c8d41;
}

.shell-header h2 {
  margin: 0;
  color: #132218;
}

.faq-list {
  display: grid;
  gap: 1rem;
}

.faq-card {
  overflow: hidden;
  border: 1px solid rgba(28, 68, 38, 0.08);
  border-radius: 22px;
  background: linear-gradient(180deg, rgba(251, 253, 251, 0.96), rgba(241, 247, 242, 0.96));
  box-shadow: 0 12px 32px rgba(20, 55, 31, 0.05);
}

.faq-card__trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 1.1rem 1.2rem;
  border: 0;
  background: transparent !important;
  color: inherit !important;
  text-decoration: none !important;
  box-shadow: none !important;
}

.faq-card__content {
  display: flex;
  align-items: center;
  gap: 0.95rem;
  min-width: 0;
  text-align: left;
}

.faq-card__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  flex-shrink: 0;
  border-radius: 14px;
  background: rgba(48, 171, 76, 0.1);
  color: #2a8a43;
  font-size: 1rem;
}

.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}

.faq-card__text {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
}

.faq-card__title {
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.4;
  color: #173021;
}

.faq-card__meta {
  font-size: 0.78rem;
  color: #6a8174;
}

.faq-card__actions {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  margin-left: 1rem;
  flex-shrink: 0;
}

.faq-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 12px;
  background: #edf7ef;
  color: #2a8a43;
  text-decoration: none;
}

.faq-action--danger {
  background: #fff1f1;
  color: #c04d4d;
}

.faq-card__collapse {
  border-top: 1px solid rgba(28, 68, 38, 0.08);
}

.faq-card__answer {
  padding: 1rem 1.2rem 1.2rem 4.1rem;
  color: #53685c;
  line-height: 1.7;
}

@media (max-width: 991px) {
  .faq-page {
    padding-top: 0.5rem;
  }

  .admin-nav {
    margin-top: 0.5rem;
    margin-bottom: 0.85rem;
  }

  .faq-shell {
    margin-top: 1.25rem;
  }

  .faq-hero {
    margin-top: 0;
  }

  .faq-hero {
    flex-direction: column;
    align-items: flex-start;
  }

  .hero-metrics {
    width: 100%;
    min-width: 0;
  }
}

@media (max-width: 767px) {
  .faq-page {
    padding: 0.5rem 0 0;
  }

  .admin-nav {
    margin-top: 0.25rem;
  }

  .faq-hero,
  .faq-shell {
    padding: 1.2rem;
    border-radius: 22px;
  }

  .hero-metrics {
    grid-template-columns: 1fr;
  }

  .hero-action {
    width: 100%;
    justify-content: center;
  }

  .faq-card__trigger {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .faq-card__actions {
    margin-left: 0;
  }

  .faq-card__answer {
    padding-left: 1.2rem;
  }
}

@media (max-width: 600px) {
  .admin-nav {
    margin-top: 0.2rem;
  }
}
</style>
